import config from "config";
import RequestUtils from "utils/RequestUtils";
import GetArcGISToken from "utils/GetArcGISToken";

export default class Mode3DQueue {
  static pingTimer = undefined;

  static async ping() {
    if (GetArcGISToken.user.iu === "g") return true;
    try {
      await RequestUtils.makeHttpQuery(
        config.ginfo3dQueueUrl + "/ping.aspx",
        "GET",
        {},
        true
      );
      return true;
    } catch (e) {
      console.debug(e);
      return false;
    }
  }

  static async exit() {
    if (GetArcGISToken.user.iu === "g") return;
    Mode3DQueue.clearPingTimer();
    return await RequestUtils.makeHttpQuery(
      config.ginfo3dQueueUrl + "/exit.aspx",
      "GET",
      {},
      true
    );
  }

  static async addLog() {
    return await RequestUtils.makeHttpQuery(
      config.webSrvUrl + "WebAPI/GInfo/AccessLog",
      "POST",
      { Key: "3D" },
      true
    );
  }

  static registerPingTimer() {
    if (GetArcGISToken.user.iu === "g") return;
    Mode3DQueue.pingTimer = setInterval(() => {
      Mode3DQueue.ping();
    }, 2 * 60 * 1000);
  }

  static clearPingTimer() {
    clearInterval(Mode3DQueue.pingTimer);
  }
}
